import type React from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { Button } from "@similarweb/ui-components";
import type {
    IBaseStep,
    IStepMetadata,
} from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { EStepState } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { StepHeader } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/StepHeader";
import {
    StepWrapper,
    Body,
    Description,
    AdditionsWrapper,
    ButtonsWrapper,
    ButtonsLeft,
    CollapsibleWrapper,
} from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/StepStyled";

export enum EWizardLegendItemState {
    NOT_VISITED,
    ACTIVE,
    COMPLETED,
}

export const Step: React.FC<IBaseStep & IStepMetadata> = ({
    isOpen,
    isOpening,
    title,
    description,
    additions,
    onStepSkip,
    buttonsList,
    onClickHoverButton,
    stepState,
    index,
}) => {
    const i18n = i18nFilter();

    return (
        <StepWrapper isOpen={isOpen}>
            <StepHeader
                isOpen={isOpen}
                isSkip={stepState == EStepState.SKIP}
                onClick={onClickHoverButton}
                title={title}
                buttonText={
                    stepState == EStepState.COMPLETED || stepState == EStepState.SKIP
                        ? i18n("growth.homepage.activationWizard.retakeStep")
                        : i18n("growth.homepage.activationWizard.openStep")
                }
                itemState={
                    stepState == EStepState.COMPLETED
                        ? EWizardLegendItemState.COMPLETED
                        : isOpen
                          ? EWizardLegendItemState.ACTIVE
                          : EWizardLegendItemState.NOT_VISITED
                }
                stepIndex={index}
            />
            <CollapsibleWrapper
                isActive={isOpen}
                isOpening={isOpening}
            >
                <Body>
                    <Description>{description}</Description>
                    {additions ? <AdditionsWrapper>{additions}</AdditionsWrapper> : null}
                    <ButtonsWrapper data-automation={"buttons-wrapper"}>
                        <ButtonsLeft>{buttonsList}</ButtonsLeft>
                        <Button
                            type={"flatDark"}
                            height={"36px"}
                            onClick={onStepSkip}
                        >
                            {i18n("growth.homepage.activationWizard.buttonSkip")}
                        </Button>
                    </ButtonsWrapper>
                </Body>
            </CollapsibleWrapper>
        </StepWrapper>
    );
};
